export const languageList = [
  { code: 'de', name: 'Deutsch', icon: '🇩🇪' },
  { code: 'en', name: 'English', icon: '🇬🇧' },
  { code: 'fr', name: 'Français', icon: '🇫🇷' },
  { code: 'it', name: 'Italiano', icon: '🇮🇹' },
  { code: 'es', name: 'Español', icon: '🇪🇸' },
  { code: 'pt', name: 'Português', icon: '🇵🇹' },
  { code: 'ja', name: '日本語', icon: '🇯🇵' },
  { code: 'ar', name: 'العربية', icon: '🇸🇦' },
  { code: 'zh', name: '中文', icon: '🇨🇳' },
  { code: 'ko', name: '한국어', icon: '🇰🇷' },
  { code: 'th', name: 'ไทย', icon: '🇹🇭' },
  { code: 'zh-HK', name: '繁體中文', icon: '🇭🇰' },
]

export const getLanguage = (code: string) => {
  return languageList.find((l) => l.code === code)
}
